import styled from "@emotion/styled";
import { color } from "@smartsheet/design-tokens-react";
import { sizes } from "../../../constants/spacing";

export const StyledModalActionSeparator = styled("div")`
    background-color: ${color("color--background--surfaces--overlay")};
    width: 2px;
    height: ${sizes.large}px;
`;
